
import {React, useEffect} from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from '@ant-design/icons';
import kiwi from '../media/KIWI.jpg'
import raspberry from '../media/Raspberry.jpg';
import strawberry from '../media/Photos/Strawberry.jpg';
import logo from "../media/Brahma Jyoti Multi Agro Farm.png"
import sheep from "../media/Photos/Sheeps.jpg";
import manhoney from "../media/Photos/Man in Honeyy.jpg";
import cow from "../media/Photos/Cow farming.jpg";
import smartfarming from "../media/Photos/Smart Farming.jpg";
import drone from "../media/Photos/Drone.jpg";
import coffee from "../media/Photos/Coffee.jpg";




const BrahmaJyotiAgroFarm = () => {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  }
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
    return(
        <div className="about-container">'
        <div className="content-left"> 
        <p style={{ display: 'flex' }}>
          <ArrowLeftOutlined onClick={goBack}></ArrowLeftOutlined>Go back
        </p>
        <h1 className="title">BRAHMA JYOTI MULTI AGRO-FARM LTD</h1>
        <div style={{textAlign: 'center'}}>
        <img src={logo} alt={logo} width={300} />
        </div>
        
        <div className="section company-details">
          <h2>Company Details</h2>
          <p><strong>Company Name:</strong> Brahma Jyoti Multi Agricultural Farm Limited</p>
          <p><strong>Industry:</strong> Agriculture</p>
          <p><strong>Specialization:</strong> Kiwi Farming and Livestock Management</p>
          <p><strong>Headquarters:</strong> Koteshwor 32, Kathmandu, Nepal</p>
        
        </div>
  
        <div className="section about-us">
          <h2>About Us</h2>
          <p>Brahma Jyoti Multi Agricultural Farm Limited is a pioneering agricultural enterprise based in Nepal, dedicated to advancing the sector through innovative kiwi farming and comprehensive livestock management. With a focus on sustainability and excellence, we are committed to enhancing productivity and fostering growth in Nepal’s agricultural landscape.</p>
          <p><strong>Our Mission:</strong> To produce high-quality kiwi fruits and offer integrated livestock management solutions that boost efficiency, sustainability, and economic benefits for farmers and communities in Nepal.</p>
        </div>
  
        <div className="section expertise">
    
          <h2>Core Areas of Expertise</h2>
          <ul>
            <li><strong>Kiwi Farming:</strong>
              <ul>
                <li><strong>Premium Kiwi Production:</strong> We specialize in cultivating top-grade kiwi fruits, utilizing advanced farming techniques and sustainable practices to ensure the highest quality and yield.</li>
                <li><strong>Innovative Cultivation Practices:</strong> Our approach incorporates cutting-edge technology and research to optimize growing conditions, enhance fruit quality, and minimize environmental impact.</li>
              </ul>
            </li>
            <div style={{textAlign: 'center'}} >
          <img src={kiwi} alt="kiwi" width={200}></img>
          <img src={raspberry} alt="raspberry" width={200}></img>
          <img src={strawberry} alt="raspberry" width={200}></img>
          </div>
          
            <li><strong>Livestock Management:</strong>
              <ul>
                <li><strong>Comprehensive Livestock Solutions:</strong> We provide expert services in the management of various livestock species, including cattle, goats, and poultry, focusing on breeding, health, and nutrition to improve productivity and welfare.</li>
                <li><strong>Health and Wellness:</strong> Our team implements rigorous health management protocols, including disease prevention and veterinary care, to maintain the well-being of our livestock.</li>
                <li><strong>Nutritional Strategies:</strong> We develop tailored feeding programs to meet the specific needs of different livestock, promoting optimal growth and production.</li>
                <li><strong>Sustainable Livestock Practices:</strong> We adopt sustainable management practices that reduce environmental impact and enhance the efficiency of resource use.</li>
              </ul>
            </li>
            <div style={{textAlign: 'center'}} >
          <img src={sheep} alt="sheep" width={200}></img>
          <img src={manhoney} alt="manhoney" width={200}></img>
          <img src={cow} alt="cow" width={200}></img>
          </div>
            <li><strong>Multi-Functional Agricultural Services:</strong>
              <ul>
                <li><strong>Farm Consultancy:</strong> We offer expert consultancy in both crop and livestock management, providing solutions to enhance operational efficiency and sustainability.</li>
                <li><strong>Soil and Water Management:</strong> Our services include soil testing, fertility management, and irrigation solutions designed to support healthy crop growth and efficient water use.</li>
                <li><strong>Technology Integration:</strong> We integrate modern agricultural technologies and data analytics to optimize farm management and productivity.</li>
              </ul>
            </li>
            <div style={{textAlign: 'center'}} >
          <img src={coffee} alt="coffee" width={200}></img>
          <img src={drone} alt="drone" width={200}></img>
          <img src={smartfarming} alt="smartfarming" width={200}></img>
          </div>
          </ul>
        </div>
  
        <div className="section sustainability">
          <h2>Sustainability Commitment</h2>
          <p>Brahma Jyoti Multi Agricultural Farm Limited is deeply committed to sustainable practices that protect and enhance the environment. Our farming and livestock management approaches focus on reducing waste, conserving resources, and promoting biodiversity. We strive to ensure that our operations contribute positively to both the environment and the local communities in Nepal.</p>
        </div>
  
        <div className="section community-engagement">
          <h2>Community Engagement</h2>
          <p>We believe in empowering local communities and actively engage with them through educational programs and partnerships. By providing training and resources, we support local farmers in adopting best practices and improving their agricultural productivity.</p>
        </div>
  
        <div className="section future-vision">
          <h2>Future Vision</h2>
          <p>Looking ahead, Brahma Jyoti Multi Agricultural Farm Limited aims to expand its presence in kiwi farming and livestock management across Nepal. We are dedicated to continual innovation and adoption of sustainable practices, with a vision to drive growth and sustainability in the agricultural sector.</p>
        </div>
  
        <div className="section contact-us">
          <h2>Contact Us</h2>
          <p>For more information about our services, partnerships, or to explore potential collaborations, please visit our website or contact us.</p>
        </div>
      </div>
       
      </div>
    )
}

export default BrahmaJyotiAgroFarm;